export * from '@/features/notifications/types'
export type {
  MarkAllReadResult,
  NotificationsListResult,
} from '@/features/notifications/api/notifications.api'
export {
  useNotifications,
  useMarkNotificationRead,
  useMarkAllNotificationsRead,
} from '@/features/notifications/hooks/use-notifications'
export { useNotificationSocket } from '@/features/notifications/hooks/use-notification-socket'
